import { render } from "./SelectSingleField.vue?vue&type=template&id=03bc520e"
import script from "./SelectSingleField.vue?vue&type=script&lang=js"
export * from "./SelectSingleField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__